import Marquee from "react-fast-marquee";

const ITEMS = ["Commercial Builds", "Civil Engineering", "Renovation", "Interiors", "Infrastructure", "Fit-Outs"];

export const Ribbon = () => {
  return (
    <div className="border-y border-line bg-ink py-6 md:py-8" data-testid="ribbon-marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-heading font-black tracking-tighter text-4xl md:text-6xl marquee-outline px-8">
              {item}
            </span>
            <span className="h-3 w-3 rotate-45 bg-flame mx-4" />
          </div>
        ))}
      </Marquee>
    </div>
  );
};
